import React from 'react';

const ArrowColumn = () => (
  <div className="collapsible-value show-for-large text-center">
    <i className="fa collapse-btn fa-angle-down-btb" />
  </div>
);

export default ArrowColumn;
